import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { TheProblem } from '../components/TheProblem';
import { WhyItDidntWork } from '../components/WhyItDidntWork';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-dark-navy text-stone-200 font-sans" data-id="element-166">
      <Hero data-id="element-167" />
      <OpeningHook data-id="element-168" />
      <TheProblem data-id="element-169" />
      <WhyItDidntWork data-id="element-170" />
      <UniqueMechanism data-id="element-171" />
      <WhatYouGet data-id="element-172" />
      <WhoThisIsFor data-id="element-173" />
      <HowItWorks data-id="element-174" />
      <Proof data-id="element-175" />
      <Testimonials data-id="element-176" />
      <FAQ data-id="element-177" />
      <FinalOffer data-id="element-178" />
      <Footer data-id="element-179" />
    </div>;
}